import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'
import FieldsEmployeeSimple from 'graphql/fields/FieldsEmployeeSimple'

const fields = {
	'guid': '[String]',
	'team_guid': 'String',
	'visible_for_employees': '[String]',
	'kind': '[String]',
	'verified': '[String]',
	'active': '[String]',
};

export default gql(`
	query employees( ${ HelperGraphql.createFields( fields ) } )  {
		employees( ${ HelperGraphql.createVariables( fields ) } )  {
			${FieldsEmployeeSimple}
		}
	}
`);

